var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mr-10 flex overflow-x-auto"},_vm._l((_vm.compseries),function(c){return _c('div',{key:c.name},[_c('SensorStatusGraph',{attrs:{"series":c}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }